import React from "react";
import DefaultButton from "../../components/DefaultButton";
import { Link } from "react-router-dom";
export default function SustainDiscuss() {
  return (
    <>
      <section className="sustaindiscuss-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="sustaindiscuss-mainbox">
                <div className="row justify-content-center">
                  <div className="col-lg-9 text-center">
                    <h4 className="heading"> Want to know more? Reach out to us—we’d be happy to discuss your needs.</h4>
                    <span> Give our specialists a call on <Link target="_blank" to="tel:+91-9580 374 374"> +91-9580 374 374</Link></span>
                    <DefaultButton text={"Contact Us"} to={"/contact"} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
